/**
Coded by www.techhighway.ca

*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

const MDTabPanel = forwardRef(({ children, value, index, ...rest }, ref) => {
  const [controller] = useMaterialUIController();
  return (
    <div
      role="tabpanel"
      ref={ref}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...rest}
    >
      {value === index && (
        <MDBox sx={{ p: 3 }}>
          <MDTypography>{children}</MDTypography>
        </MDBox>
      )}
    </div>
  );
});

// Typechecking props for the MDButton
MDTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default MDTabPanel;
